<div
  class="table"
  [ngClass]="showingDetails ? 'showing-details' : ''"
  [ngClass]="hasActions ? 'has-random-actions' : ''"
>
  <div
    id="searchbar"
    class="search-bar searching"
    [ngClass]="{'searching': searching, tallTable: 'tallTable'}"
  >
    <div class="search-container">
      <label for="search" class="search-icon">
        <mat-icon class="">search</mat-icon>
      </label>
      <input
        aria-label="Search"
        (keyup)="onKey($event)"
        [ngClass]="searching ? 'searching' : ''"
        class="search-input"
        placeholder="Search"
        [(ngModel)]="query"
        name="search"
      />

    </div>
    <button mat-button (click)="new()" class="primary-btn add-button" *ngIf="!settings.noCreate" ><mat-icon style="font-size: 20px; transform: translateY(1px)">add</mat-icon> Create New</button>
  </div>
  <table>
    <caption class="table-caption" style="display: none;">{{ settings.name }}'s Table</caption> <!-- This is for accessibility purposes -->
    <tr class="row headings" [ngClass]="showingDetails ? 'showing-details' : ''">
      <th
        *ngFor="let column of columns"
        class="cell heading"
        (click)="sort(column)"
        tabindex="0"
        onkeypress="sort(column)"
      >
        <span>{{ column.label }}<mat-icon class="sort-icon">unfold_more</mat-icon></span>
      </th>

      <th
        class="cell heading row-action-button"
        [ngClass]="showingDetails ? 'showing-details' : ''"
        *ngIf="!hideMenu"
      >
      </th>
    </tr>
    <div class="rows" [ngClass]="{'showing-details': showingDetails, 'tall-table': tallTable}">
      <td class="row" *ngIf="!rows || rows.length === 0">
        <div class="cell">No {{ settings.name }}'s' found</div>
      </td>
      <tr
        *ngFor="
          let row of rows | slice: start:start + numberOfRows.value;
          let i = index
        "
        class="row content-row"
        (click)="selectRow(row)"
        (dblclick)="edit(row)"
        [ngClass]="selected === row ? 'selected' : ''"
        (keypress)="rowEnter($event, row)"
        tabindex="0"
      >
        <td *ngFor="let column of columns" class="cell td">
            <ng-container
              *ngTemplateOutlet="
                tableCellTemplate;
                context: { cell: getCellData(column, row)}
              "
                        >
            </ng-container>
          </td>
        <div *ngIf="!hideMenu" class="cell row-action-button">
          <button id="meataball" class="edit-delete-button meatball" (click)="showRowMenu(row, i)">⋮</button>
        </div>
        <div
          class="settings-menu"
          *ngIf="showingRowMenu === i"
          [ngClass]="showingDetails ? 'showing-details' : ''"
        >
          <button class="menu-item" *ngIf="selected" (click)="edit(selected)">
            Edit {{ settings.name }}
          </button>
          <button id="deletebutton" class="menu-item" *ngIf="selected" (click)="delete(selected)">
            Delete {{ settings.name }}
          </button>
        </div>
      </tr>
    </div>
  </table>
  <div class="pagination-container">
    <span class="showing"
      >{{ start + 1 }} -
      {{
        start + numberOfRows.value > rows.length
          ? rows.length
          : start + numberOfRows.value
      }}
      of {{ rows.length }}</span
    >

    <div class="actions">
      <app-dropdown
        [choice]="numberOfRows"
        label="Rows per page: "
        [options]="[
          {
            name: '10',
            value: 10
          },
          {
            name: '25',
            value: 25
          },
          {
            name: '50',
            value: 50
          }
        ]"
        key="name"
        (selectedDropdownItem)="numberOfRows = $event"
      ></app-dropdown>
      <div class="page-arrows">
        <button class="arrow" (click)="pageLeft()">
          <mat-icon>chevron_left</mat-icon>
        </button>
        <span class="page-number"> {{ getPageRatio() }}</span>
        <button class="arrow" (click)="pageRight()">
          <mat-icon>chevron_right</mat-icon>
        </button>
      </div>
    </div>
  </div>
</div>
